import { render, staticRenderFns } from "./ProjectPolicyViolations.vue?vue&type=template&id=0e982145&"
import script from "./ProjectPolicyViolations.vue?vue&type=script&lang=js&"
export * from "./ProjectPolicyViolations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e982145')) {
      api.createRecord('0e982145', component.options)
    } else {
      api.reload('0e982145', component.options)
    }
    module.hot.accept("./ProjectPolicyViolations.vue?vue&type=template&id=0e982145&", function () {
      api.rerender('0e982145', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/projects/ProjectPolicyViolations.vue"
export default component.exports